// ============================================
// CONFIG LANDING PAGE — QOD ENGULFING NEWBIE
// ONBOARD WEBINAR
// ============================================

// Link Telegram admin (semua butang CTA "PM ADMIN TO JOIN")
export const TELEGRAM_URL = "https://t.me/m/eO_LnKvkZjQ1";

// Meta Pixel ID — dipasang terus dalam public/index.html (head).
export const META_PIXEL_ID = "950428814807062";

// Event custom "TelegramClick" — HANYA apabila pelawat klik butang
// Telegram. (Event Subscribe lama dikekalkan di bawah sebagai helper
// untuk kegunaan organisers pada masa depan — ia TIDAK ditembak
// secara automatik semasa buka borang atau klik Telegram.)
export const trackTelegramClick = (location) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("trackCustom", "TelegramClick", {
            content_name: "Telegram CTA",
            cta_location: location,
        });
    }
};

// Dikekalkan daripada integrasi lama — hanya dipangil apabila
// penganjur takrifkan momen "Subscribe" yang sebenar.
export const trackSubscribe = () => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "Subscribe", {
            content_name: "Webinar Registration",
        });
    }
};

// Event "CompleteRegistration" — HANYA selepas borang pendaftaran
// berjaya dihantar & disimpan dalam backend (bukan semasa load).
export const trackCompleteRegistration = () => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "CompleteRegistration", {
            content_name: "Webinar Registration Form",
        });
    }
};

// Scroll lancar ke seksyen borang pendaftaran (guna Lenis jika aktif).
export const scrollToRegistration = () => {
    const el = document.getElementById("registration-form");
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
